import {
  Box,
  Typography,
  Container,
  Card,
  CardContent,
  IconButton,
  Collapse,
} from "@mui/material";

import config from "config/API";

const DOMAIN = config.DOMAIN;

const Link = ({ link, text }) => {
  return (
    <Typography
      component="a"
      href={`${DOMAIN}${link}`}
      sx={{ color: "primary.main", fontSize: "inherit" }}
      target="_blank"
    >
      {text}
    </Typography>
  );
};
const HowItWorkPage = () => {
  return (
    <Box sx={{ mt: 4 }}>
      <Container maxWidth="lg">
        <Typography sx={{ mb: 5 }} textAlign="center" variant="h4">
          Как начать работать?
        </Typography>
        <Container maxWidth="md">
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" fontWeight="bold" mb={2}>
                1. Регистрация и активация аккаунта
              </Typography>
              <Typography color="text.secondary" paragraph>
                Для начала работы пройдите процесс регистрации на платформе,
                указав необходимые данные, после чего подтвердите создание
                аккаунта, перейдя по ссылке из письма, которое придет на
                указанную вами электронную почту.
              </Typography>

              <Typography variant="h6" fontWeight="bold" mb={2}>
                2. Настройка аккаунта
              </Typography>
              <Typography color="text.secondary" paragraph>
                После активации аккаунта перейдите в раздел{" "}
                <Link link="/panel/account" text="Настройки аккаунта" /> для
                завершения настройки.
              </Typography>

              <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                2.1. Подключение Telegram
              </Typography>
              <Typography color="text.secondary" paragraph>
                Чтобы подключить Telegram, нажмите на кнопку{" "}
                <strong>"+"</strong> рядом с полем <strong>Telegram</strong>,
                затем в открывшемся окне нажмите <strong>"Подписаться"</strong>,
                после чего вас автоматически перенаправит на нашего
                Telegram-бота, где вы сможете завершить авторизацию и
                подтвердить подключение.
              </Typography>

              <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                2.2. Настройка режима работы
              </Typography>
              <Typography color="text.secondary" paragraph>
                Включите режим <strong>"В работе"</strong>, чтобы начать
                получать заявки на перевод средств, и при необходимости укажите
                удобное время для работы, если это требуется для вашего графика.
              </Typography>

              <Typography variant="h6" fontWeight="bold" mb={2}>
                3. Пополнение баланса и добавление реквизитов банков
              </Typography>

              <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                3.1. Пополнение страхового баланса
              </Typography>
              <Typography color="text.secondary" paragraph>
                Для получения заявок на перевод средств вам нужно пополнить
                страховой баланс. Перейдите на страницу{" "}
                <Link link="/panel/transfers" text="Пополнение баланса" />,
                нажмите кнопку <strong>"Пополнить депозит"</strong>, введите
                требуемые данные в открывшемся окне и создайте заявку. После
                этого переведите указанную сумму на предоставленный адрес{" "}
                <strong>USDT-TRC20</strong>, нажмите{" "}
                <strong>"Я оплатил"</strong> и дождитесь подтверждения от
                системы. Ваш баланс будет пополнен на сумму в рублях по текущему
                курсу, который указан на панели выше.
              </Typography>

              <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                3.2. Добавление реквизитов банков
              </Typography>
              <Typography color="text.secondary" paragraph>
                Чтобы добавить реквизиты банковских карт, перейдите на страницу{" "}
                <Link link="/panel/requisites" text="Реквизиты" />, выберите
                банк, с которым вы хотите работать, и нажмите{" "}
                <strong>"Добавить"</strong>, после чего заполните все
                необходимые поля в открывшемся окне. Когда все нужные карты
                будут добавлены, выберите их и отправьте на проверку. После
                успешной проверки ваши карты переместятся в категорию{" "}
                <strong>"Одобренные"</strong>, где вы сможете управлять их
                настройками: включать или выключать, устанавливать лимиты на
                баланс, максимальное количество переводов в день или общую сумму
                переводов.
              </Typography>

              <Typography variant="h6" fontWeight="bold" mb={2}>
                4. Сделки
              </Typography>

              <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                4.1. Уведомления о сделках
              </Typography>
              <Typography color="text.secondary" paragraph>
                Все входящие сделки будут поступать как на платформу, так и в
                Telegram-бот, что позволит вам оперативно реагировать на новые
                заявки.
              </Typography>

              <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                4.2. Получение средств
              </Typography>
              <Typography color="text.secondary" paragraph>
                Чтобы получать заявки на получение средств, убедитесь, что ваш
                страховой баланс пополнен. Как только вы получите заявку,
                система временно заморозит часть вашего страхового баланса на
                сумму заявки до тех пор, пока Вы не подтвердите получение
                средств или пока мы не подтвердим, что сумма не была Вам
                отправлена. В течение указанного в заявке времени вам необходимо
                подтвердить поступление средств.
              </Typography>

              <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                4.3. Перевод средств
              </Typography>
              <Typography color="text.secondary" paragraph>
                После подтверждения отправки средств система автоматически
                спишет сумму с вашего основного баланса, поэтому убедитесь, что
                на основном балансе достаточно средств для выполнения операции.
              </Typography>

              <Typography
                // color="text.secondary"
                textAlign="center"
                variant="h6"
                mt={5}
              >
                Теперь ваш аккаунт полностью настроен, и вы готовы к работе.
                Если у вас возникнут вопросы, обратитесь в службу поддержки для
                получения помощи.
              </Typography>
            </CardContent>
          </Card>
        </Container>
      </Container>
    </Box>
  );
};

export default HowItWorkPage;
